/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type UseCallAlertsVehicleFragment = {
  __typename?: 'Vehicle'
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      createdAt: string
    }>
  } | null
}

export const UseCallAlertsVehicleFragmentDoc = gql`
    fragment UseCallAlertsVehicle on Vehicle {
  fccCurrentAdAlerts {
    alerts {
      id
      type
      createdAt
    }
  }
}
    `
